import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { component } from 'Helpers/PropTypes';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSelectionContextState } from '../SelectionContext';

const styles = () => ({
  root: {},
  header: {},
  detail: {},
});

const Detail = ({
  className,
  classes,
  showEmptyState,
  DetailComponent,
  HeaderComponent,
}) => {
  const { selectedResource } = useSelectionContextState();

  if (!selectedResource && !showEmptyState) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {HeaderComponent ? (
        <HeaderComponent
          className={classes.header}
          resource={selectedResource}
        />
      ) : null}
      <DetailComponent
        className={classes.detail}
        resource={selectedResource}
      />
    </Box>
  );
};

Detail.defaultProps = {
  className: '',
  showEmptyState: false,
  HeaderComponent: null,
};

Detail.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  showEmptyState: PropTypes.bool,
  DetailComponent: component.isRequired,
  HeaderComponent: component,
};

export default withStyles(styles)(Detail);
